import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../shared/PRE-LOAD/app-settings';
import { EventsService } from '../../../shared/services/events/events.service';
import { UserSelectionsService } from '../../../shared/services/user-selections/user-selections.service';
import { Product } from '../../../shared/types/product.type'
import { Journey, JourneySteps } from '../../../shared/types/strings.type'
import { Utilities } from '../../../shared/utilities/utilities';
import { JourneyConfig } from '../../config/journey';


@Component({
    selector: 'events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss', '../../styles.event.scss']
})
export class EventsComponent {

    constructor(
        private router: Router,
        private userSelectionService: UserSelectionsService,
        private eventsService: EventsService,
        private utilities: Utilities,
        private appSettings: AppSettings
    ) {
    }

    showSubmit: boolean;
    journeySteps: Array<JourneySteps> = JourneyConfig.steps;
    header: Journey = {
        title: 'Choose Your Appointment Type',
        instruction: ''
    };

    events: Array<Product>

    ngOnInit() {
        if (this.appSettings.eventName == null) {
            this.eventsService.getAllEvents().subscribe((data: Array<Product>) => {
                this.events = data
                this.skipToProceed(this.events);
            });
        } else {
            this.eventsService.getEvent(this.appSettings.eventName).subscribe((data: Array<Product>) => {
                this.events = data
                this.skipToProceed(this.events)
            });
        }



    }

    skipToProceed(events: Array<Product>) {
        if (events.length == 1) {
            this.proceed(events[0])
        }
    }

    currentDayCount($event) {
        this.showSubmit = $event > 1;
    }

    proceed(event: Product) {

        this.userSelectionService.set('product', event);
        this.userSelectionService.set('startLocation', this.utilities.startLocationAsString('on'));
        this.router.navigate(['event-appointment'], { skipLocationChange: true, fragment: 'rttd' });
    }
}
